import { render } from "./AddAccountModal.vue?vue&type=template&id=68339d3d&ts=true"
import script from "./AddAccountModal.vue?vue&type=script&lang=ts"
export * from "./AddAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__